import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { 
  AddCircleOutline as AddIcon,
  FileDownload as FileDownloadIcon,
  CloudUpload as CloudUploadIcon,
} from '@mui/icons-material';
import { colors, fonts, spacing, borderRadius } from '../../constants';

/**
 * PageHeader Component
 * Page header with description and action buttons
 */
const PageHeader = ({ onCreateUser, onImport, onExport }) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: { xs: 'column', md: 'row' },
      justifyContent: 'space-between', 
      alignItems: { xs: 'stretch', md: 'center' }, 
      mb: spacing.md, 
      mt: 0,
      gap: { xs: spacing.md, md: spacing.sm }
    }}>
      <Typography variant="body1" sx={{ 
        color: colors.textSecondary, 
        fontSize: { xs: fonts.fontSizeSm, sm: fonts.fontSizeMd }, 
        mt: 0,
        mb: { xs: spacing.xs, md: 0 }
      }}>
        Manage system users and their permissions.
      </Typography>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', sm: 'row' },
        gap: spacing.sm,
        width: { xs: '100%', sm: 'auto' },
        alignItems: { xs: 'stretch', sm: 'center' }
      }}>
        <Button
          variant="outlined"
          startIcon={<CloudUploadIcon sx={{ fontSize: '16px' }} />}
          onClick={onImport}
          fullWidth={typeof window !== 'undefined' && window.innerWidth < 600}
          sx={{
            borderColor: colors.primaryDark,
            borderWidth: '1.5px',
            color: colors.primaryDark,
            textTransform: 'none',
            borderRadius: borderRadius.button,
            fontWeight: fonts.weightSemiBold,
            fontSize: fonts.fontSizeSm,
            py: '6px',
            px: spacing.sm,
            backgroundColor: colors.backgroundWhite,
            boxShadow: `0 2px 4px ${colors.primaryShadow}`,
            minHeight: '36px',
            '&:hover': {
              borderColor: colors.primary,
              borderWidth: '1.5px',
              color: colors.primary,
              backgroundColor: colors.primarySoft,
              boxShadow: `0 4px 8px ${colors.primaryShadow}`,
            },
          }}
        >
          Import
        </Button>
        <Button
          variant="outlined"
          startIcon={<FileDownloadIcon sx={{ fontSize: '16px' }} />}
          onClick={onExport}
          fullWidth={typeof window !== 'undefined' && window.innerWidth < 600}
          sx={{
            borderColor: colors.primaryDark,
            borderWidth: '1.5px',
            color: colors.primaryDark,
            textTransform: 'none',
            borderRadius: borderRadius.button,
            fontWeight: fonts.weightSemiBold,
            fontSize: fonts.fontSizeSm,
            py: '6px',
            px: spacing.sm,
            backgroundColor: colors.backgroundWhite,
            boxShadow: `0 2px 4px ${colors.primaryShadow}`,
            minHeight: '36px',
            '&:hover': {
              borderColor: colors.primary,
              borderWidth: '1.5px',
              color: colors.primary,
              backgroundColor: colors.primarySoft,
              boxShadow: `0 4px 8px ${colors.primaryShadow}`,
            },
          }}
        >
          Export
        </Button>
        <Button
          variant="contained"
          startIcon={<AddIcon sx={{ fontSize: '16px' }} />}
          onClick={onCreateUser}
          fullWidth={typeof window !== 'undefined' && window.innerWidth < 600}
          sx={{
            background: colors.buttonPrimary,
            color: colors.buttonPrimaryText,
            textTransform: 'none',
            borderRadius: borderRadius.button,
            fontWeight: fonts.weightSemiBold,
            fontSize: fonts.fontSizeSm,
            py: '6px',
            px: spacing.sm,
            boxShadow: `0 4px 12px ${colors.primaryShadow}`,
            border: 'none',
            minHeight: '36px',
            '&:hover': {
              background: colors.buttonPrimaryHover,
              boxShadow: `0 6px 16px ${colors.primaryShadowHover}`,
              transform: 'translateY(-1px)',
            },
            '&:active': {
              transform: 'translateY(0)',
            },
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        >
          <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Create New User</Box>
          <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>Create User</Box>
        </Button>
      </Box>
    </Box>
  );
};

export default PageHeader;

